import { Link } from '@inertiajs/react'
import type { TechnologyCrumb } from '@/types/technology'

/* The visible trail, rendered from the SAME prop the BreadcrumbList schema is
 * built from, so the two cannot drift. The final crumb is the current page and
 * is not a link — a self-link there is noise for a screen reader. */
export default function TechBreadcrumbs({ crumbs }: { crumbs: TechnologyCrumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.75rem]">
        {crumbs.map((crumb, index) => (
          <li key={crumb.label} className="flex items-center gap-2">
            {index > 0 && (
              <span className="text-white/30" aria-hidden="true">
                /
              </span>
            )}
            {crumb.href ? (
              <Link href={crumb.href} prefetch className="text-white/55 no-underline transition-colors hover:text-white/85">
                {crumb.label}
              </Link>
            ) : (
              <span className="text-white/75" aria-current="page">
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
